import { HomeProvider } from "../homeProvider/HomeProvider";
import {OutletProvider} from "../../outlet/outletProvider/OutletProvider";
export default class HomeServices {
  static async selectedServices() {
    const res = await HomeProvider.getSelectedServices();
    return res.data;
  }
  static async allServices() {
    const res = await HomeProvider.getAllServices();
    return res.data;
  }

  static async serviceDetails(params: { service_id: string | undefined }) {
    const res = await HomeProvider.getServiceDetails(params);
    return res.data;
  }
  static async CampaignData() {
    const res = await HomeProvider.getCampaign();
    return res.data;
  }
  static async ShowCamaing(id:string|undefined){
    const res=await HomeProvider.getShowCampaing(id)
    return res.data
  }
  static async MostSellerData() {
    const res = await HomeProvider.getMostSeller();
    return res.data;
  }
  static async ShowProduct(params: { id?: string | number; product_id?: string | number }) {
    const res = await HomeProvider.postShowProducts(params);
    return res.data;
  }
  static async getSimilarProducts(params: { id?: string | number; product_id?: string | number; [key: string]: any }) {
    const res = await HomeProvider.getSimilarProducts(params);
    return res.data;
  }
  static async getPartnerProducts(params: { category_id?: string | number; page?: number; [key: string]: any }) {
    const res = await HomeProvider.getPartnerProducts(params);
    return res.data;
  }
  static async getPopularProducts(params?: { page?: number; per_page?: number; [key: string]: any }) {
    const res = await HomeProvider.getPopularProducts(params);
    return res.data;
  }

  static async PhonePrefixData() {
    const res = await HomeProvider.getPhonePrefix();
    return res.data;
  }
  static async AllBlogsData() {
    const res = await HomeProvider.getAllBlogsData();
    return res.data;
  }
  static async AllPartners() {
    const res = await HomeProvider.getAllPartners();
    return res.data;
  }

  static async addProductToWishlist(payload: { product_id: number }) {
    const res = await HomeProvider.postAddToWishlist(payload);
    return res.data;
  }

  static async getFavorites() {
    const res = await HomeProvider.getFavorites();
    return res.data;
  }

  static async removeFromWishlist( id: number ) {
    const res = await HomeProvider.removeFromFavorites(id);
    return res.data;
  }
  static async getOfferWeek() {
    const res = await HomeProvider.getOfferWeek();
    return res.data;
  }
  static async clearWishlist() {
    const res = await HomeProvider.clearFavorites();
    return res.data;
  }
  static async getPartnors(){
    const res=await HomeProvider.getPartnors()
    return res.data
  }
   static async getOutletHero() {
    const res = await OutletProvider.getOutletHero();
    return res.data;
  }
   static async getHomeHero() {
    const res = await HomeProvider.getHomeHero();
    return res.data;
  }
    static async getHomeHeroFeatures() {
    const res = await HomeProvider.getHomeHeroFeatures();
    return res.data;
  }
}
